import { createFileRoute } from "@tanstack/react-router";
import { ProductView } from "@/components/items/ProductView";

export const Route = createFileRoute("/_app/p/$productKey/board")({ component: View });

function View() {
  const { productKey } = Route.useParams();
  const search = Route.useSearch();
  return <ProductView productKey={productKey} layout="board" search={search} />;
}
